import { Grid, AppBar, alpha, styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const LogId = styled(NavLink)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
    fontWeight: theme.typography.fontWeightBold
  }
}));

export const LogProperty = styled('pre')(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  borderRadius: '5px',
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(1),
  marginBlock: theme.spacing(1)
}));

export const LogPropertyContainer = styled(Grid)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '& strong': {
    paddingRight: theme.spacing(1)
  }
}));

export const LogAppBar = styled(AppBar)(({ theme }) => ({
  marginBottom: theme.spacing(1.5)
}));

const logGridStyle = {
  level: {
    error: {
      background: 'linear-gradient(to right,rgba(255,255,255,1) 55%, rgba(255,0,0,0.6))'
    },
    warning: {
      background: 'linear-gradient(to right, rgba(255,255,255,1) 55%, rgba(	255, 152, 0,0.6))'
    },
    fatal: {
      background: 'linear-gradient(to right, rgba(255,255,255,1) 55%, rgba(255,0,0,0.6))'
    },
    info: {
      background: 'linear-gradient(to right, rgba(255,255,255,1) 55%, rgba(238, 238, 238,0.6))'
    }
  },
  options: {
    hoverBackground: '#FFF',
    alignItems: 'center'
  }
};

export const LogGrid = styled(Grid)(({ logLevel }) => {
  return {
    background: logGridStyle.level[logLevel]?.background ?? logGridStyle.level['info'].background,
    '&:hover': {
      background: logGridStyle.options.hoverBackground
    },
    alignItems: logGridStyle.options.alignItems
  };
});
